export default Object.freeze({
  SET_USER_DETAILS: 'SET_USER_DETAILS',
  UNSET_USER_DETAILS: 'UNSET_USER_DETAILS'
});
